import * as promotions from '../common/api/promotions';

export const FETCH_PREMIUM_PERKS = 'FETCH_PREMIUM_PERKS';
export const FETCH_PREMIUM_PERKS_SUCCESS = 'FETCH_PREMIUM_PERKS_SUCCESS';
export const FETCH_PREMIUM_PERKS_FAILURE = 'FETCH_PREMIUM_PERKS_FAILURE';

export const fetchPremiumPerks = () => async dispatch => {
  dispatch({ type: FETCH_PREMIUM_PERKS });

  try {
    const premiumPerks = await promotions.fetchPremiumPerks();
    dispatch({
      type: FETCH_PREMIUM_PERKS_SUCCESS,
      premiumPerks,
    });
  } catch (err) {
    dispatch({
      type: FETCH_PREMIUM_PERKS_FAILURE,
      error: err,
    });
  }
};
